import React from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AnalyticsTracker from "./AnalyticsTracker";
import { CartProvider } from "../src/components/CartContext";
import ScrollToTop from "../src/components/ScrollToTop";

// PAGES
import Home from "./pages/Home";
import CeleMaiVindute from "./pages/CeleMaiVindute";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import SearchResults from "./components/SeachResult";
import Cos from "./pages/Cos";
import BucheteMireasa from "./pages/BucheteMireasa";
import IntrebariFrecvente from "./components/IntrebariFrecvente";
import BuchetePremium from "./pages/BuchetePremium";
import PaisprezeceFebruarie from "./pages/14februarie";
import CumFunctioneaza from "./components/CumFunctioneaza";
import CompozitiiCutie from "./pages/CompozitiiCutie";
import OptMartie from "./pages/8martie";
import CompozitiiDeIarna from "./pages/CompozitiiDeIarna";
import BucheteIarnaPrimavara from "./pages/BucheteIarnaPrimavara";
import BucheteDeToamna from "./pages/BucheteDeToamna";
import BucheteDeVara from "./pages/BucheteDeVara";
import LivrareSiPlata from "./pages/Livrare&Plata";
import TermsAndConditions from "./pages/Termeni&conditii";
import Privacypolicy from "./pages/Privacypolicy";
import Buchete from "./pages/Buchete";
import BucheteTrandafiri from "./pages/BucheteTrandafiri";
import OrderConfirmation from "./pages/OrderConfirmation";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";

// COMPONENTS
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FlowerDetails from "./components/FlowerDetails";
import Lacetegindesti from "./components/Lacetegindesti";
import CartPopup from "./components/CartPopup";
import Checkout from "./pages/Checkout";

function App() {
  return (
    <CartProvider>
      <Router>
        <AnalyticsTracker />
        <ScrollToTop />

        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cele-mai-vindute" element={<CeleMaiVindute />} />
          <Route path="/buchete" element={<Buchete />} />
          <Route path="/buchete-trandafiri" element={<BucheteTrandafiri />} />
          <Route
            path="/compozitii-in-cosuri-si-cutii"
            element={<CompozitiiCutie />}
          />
          <Route path="/buchete-premium" element={<BuchetePremium />} />
          <Route path="/14-februarie" element={<PaisprezeceFebruarie />} />
          <Route path="/8-martie" element={<OptMartie />} />
          <Route path="/buchete-de-mireasa" element={<BucheteMireasa />} />
          <Route path="/compozitii-de-iarna" element={<CompozitiiDeIarna />} />
          <Route
            path="/buchete-de-iarna/primavara"
            element={<BucheteIarnaPrimavara />}
          />
          <Route path="/buchete-de-vara" element={<BucheteDeVara />} />
          <Route path="/buchete-de-toamna" element={<BucheteDeToamna />} />
          <Route path="/despre-noi" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/intrebari-frecvente" element={<IntrebariFrecvente />} />
          <Route path="/cum-functioneaza" element={<CumFunctioneaza />} />
          <Route path="/lacetegindesti" element={<Lacetegindesti />} />
          <Route path="/livrare-si-plata" element={<LivrareSiPlata />} />
          <Route path="/search-results" element={<SearchResults />} />
          <Route path="/termeni-si-conditii" element={<TermsAndConditions />} />
          <Route
            path="/politica-de-confidentialitate"
            element={<Privacypolicy />}
          />
          {/* Cart routes */}
          <Route path="/cos" element={<Cos />} />
          <Route path="/checkout" element={<Checkout />} />
          {/* Payment routes */}

          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failed" element={<PaymentFailed />} />
          {/* Flower details */}
          <Route path="/flower/:id" element={<FlowerDetails />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
        </Routes>

        <CartPopup />
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
